// TODO: this has been generalize so give it a more general name and consolidate with bookmark locator
import _ = require("underscore");
import Portal = require("portal-gis");
import Utils = require("../utils");
import geo = require("../utils/geo");
import StringDistance = require("../utils/levenshtein-distance");
import Base = require("./base/locator");

class Command extends Base {

    static about = `Extends base/locator to perform a text search against all features`;

    static options = Utils.defaults({
        "model": {
            "about": "The model to search",
            "default": "api.features",
        },
        "search-field":  {
            "about": "The field to search",
            "default": "text",
        },
        "panmap":  {
            "about": "Allow the map to pan?",
            "default": "true",
        },
        "event":  {
            "default": "feature-locator",
        }
    }, Base.options);

    execute(args = this.args) {

        _.defaults(this.asOptions(Command.options), {
            model: this.mediator.api.features
        });

        super.execute(args);

    }
}

export = Command; 